import { useEffect, useRef, useState } from "react";
import {
  CONSTRAINT_MARKER_SETTINGS_EVENT,
  readConstraintMarkerSettings,
} from "../../selected-constraint-visibility/markerSettingsEvents";

export function useConstraintMarkerLayerState({
  constraintVisibilityUi,
  equalityMarkerVisibility,
  selectedEquality,
  selectedTendon,
  showConstraintMarkers,
  tendonMarkerVisibility,
}) {
  const [constraintMarkersRetryNonce, setConstraintMarkersRetryNonce] = useState(0);
  const [constraintMarkerSettings, setConstraintMarkerSettings] = useState(() =>
    readConstraintMarkerSettings()
  );
  const constraintMarkerLayerVisible =
    showConstraintMarkers && constraintVisibilityUi.constraintsVisible !== false;
  const tendonMarkerLayerVisible =
    showConstraintMarkers && constraintVisibilityUi.tendonsVisible !== false;
  const constraintMarkerLayerStateRef = useRef({
    showConstraintMarkers: false,
    constraintsVisible: true,
    tendonsVisible: true,
    selectedEquality: null,
    selectedTendon: null,
    equalityMarkerVisibility: {},
    tendonMarkerVisibility: {},
    constraintFocus: false,
  });

  useEffect(() => {
    const handleConstraintMarkerSettings = (event) => {
      setConstraintMarkerSettings({
        ...readConstraintMarkerSettings(),
        ...(event?.detail || {}),
      });
    };
    window.addEventListener(CONSTRAINT_MARKER_SETTINGS_EVENT, handleConstraintMarkerSettings);
    return () =>
      window.removeEventListener(CONSTRAINT_MARKER_SETTINGS_EVENT, handleConstraintMarkerSettings);
  }, []);

  useEffect(() => {
    constraintMarkerLayerStateRef.current = {
      showConstraintMarkers,
      constraintsVisible: constraintVisibilityUi.constraintsVisible !== false,
      tendonsVisible: constraintVisibilityUi.tendonsVisible !== false,
      selectedEquality,
      selectedTendon,
      equalityMarkerVisibility,
      tendonMarkerVisibility,
      constraintFocus: !!constraintVisibilityUi.focus,
    };
  }, [
    showConstraintMarkers,
    constraintVisibilityUi.constraintsVisible,
    constraintVisibilityUi.tendonsVisible,
    constraintMarkerLayerVisible,
    tendonMarkerLayerVisible,
    selectedEquality,
    selectedTendon,
    equalityMarkerVisibility,
    tendonMarkerVisibility,
    constraintVisibilityUi.focus,
  ]);

  return {
    constraintMarkerLayerStateRef,
    constraintMarkerLayerVisible,
    constraintMarkerSettings,
    constraintMarkersRetryNonce,
    setConstraintMarkersRetryNonce,
    tendonMarkerLayerVisible,
  };
}
